import { render, staticRenderFns } from "./BrandingSection.vue?vue&type=template&id=23417364&scoped=true&"
import script from "./BrandingSection.vue?vue&type=script&lang=js&"
export * from "./BrandingSection.vue?vue&type=script&lang=js&"
import style0 from "./BrandingSection.vue?vue&type=style&index=0&id=23417364&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23417364",
  null
  
)

export default component.exports